// Official CAP test constants
export const TEST_CONFIG = {
  TOTAL_QUESTIONS: 100,
  EXTENSION_QUESTIONS: 25, // for mercancías/viajeros extension
  SCORING: {
    CORRECT: 1,      // +1 point for correct answers
    INCORRECT: -0.5, // -0.5 points for incorrect answers
    UNANSWERED: 0    // 0 points for unanswered
  },
  PASSING_SCORE: 50  // Minimum points to pass
};